import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TagsComponent } from './components/tags/tags.component';
import { VideosComponent } from './components/videos/videos.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';
import { TagComponent } from './components/tag/tag.component';
import { LoginComponent } from './pages/login/login.component';
import { SearchPageComponent } from './pages/search-page/search-page.component';
import { VideosByTagComponent } from './pages/videos-by-tag/videos-by-tag.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { UserVideosComponent } from './pages/user-videos/user-videos.component';
import { ChannelVideosComponent } from './pages/channel-videos/channel-videos.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SharedModule } from './modules/shared/shared.module';
import { NavbarComponent } from './components/navbar/navbar.component';

// import { AlertmsgComponent } from './alertmsg/alertmsg.component';  

@NgModule({
  declarations: [
    AppComponent,
    TagsComponent,
    VideosComponent,
    SearchPageComponent,
    VideosByTagComponent,
    HomePageComponent,
    TagComponent,
    LoginComponent,
    UserVideosComponent,
    ChannelVideosComponent,
    NavbarComponent,


  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    ScrollingModule,
    SharedModule,
    MatIconModule,

  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }


